/**
 * HAFTALIK KONTROL VADESİ — tek kaynak (devir dokümanı Bölüm 6.4).
 *
 * ⚠️ TERMİNOLOJİ: "haftalık kontrol". Arayüzde "rutin kontrol" DENMEZ —
 *    iskele mevzuatında periyot haftalıktır ve aylık kontrol kavramı yoktur;
 *    "rutin" periyodu belirsiz bırakan bir kelimeydi (kullanıcı, 12.08.2026).
 *    Veritabanındaki `rutin_kontrol` olay/adım anahtarı DEĞİŞMEDİ: o saklanan
 *    bir değer, gösterim adı değil — değiştirmek geçmiş kayıtları koparırdı.
 *
 * ⚠️ BU DOSYA NEDEN VAR: "7 gün" kod tabanında ÜÇ AYRI YERE elle yazılmıştı
 *    (`faz.service.ts`, `is.service.ts`, `dikkat.ts`) ve biri 168 saat olarak
 *    ifade ediliyordu. Üçü aynı sayıyı söylüyordu ama biri değişse ötekiler
 *    sessizce eski kalırdı. Mimari ilke: *aynı kural iki yerde ayrı yazılmaz.*
 */
/** Kontrol periyodu. Mevzuat: iskele 7 günde bir kontrol edilir. */
export const KONTROL_PERIYOT_GUN = 7;
/**
 * SARI (uyarı) eşiği — vadeden bir gün önce.
 *
 * Kullanıcı kuralı: *"6. günde sarı, 7 günü aştığında kırmızı."*
 * Yani sarı pencere tam olarak bir gündür: 6. gün "yarın kontrol var" der.
 */
export const KONTROL_SARI_GUN = 6;
/**
 * Geçen güne göre durum. `gecenGun` SAYACIN değeridir — ham "son kontrol"
 * değil (bkz. `kontrolBilgisi`).
 *
 * ⚠️ `null` = ÖLÇÜLECEK BİR ŞEY YOK (iskele teslim edilmemiş). "Güncel"
 *    döner, çünkü vadesi olmayan bir şeyin vadesi geçmiş olamaz. Eskiden
 *    burada `null → 'gecti'` vardı ve bug'ın kaynağı buydu.
 */
export function kontrolDurumu(gecenGun) {
    if (gecenGun == null)
        return 'guncel';
    if (gecenGun >= KONTROL_PERIYOT_GUN)
        return 'gecti';
    if (gecenGun >= KONTROL_SARI_GUN)
        return 'yaklasiyor';
    return 'guncel';
}
/**
 * HAFTALIK KONTROL SAYACI.
 *
 * ⚠️ SAYAÇ TESLİMDEN BAŞLAR, kurulumdan değil. Kontrol/teslim adımı
 *    tamamlanmış bir iskelenin ilk haftalık kontrol vadesi teslim tarihinden
 *    işler; henüz hiç kontrol edilmemiş olması onu gecikmiş yapmaz.
 *
 * @param sonKontrolGun Son haftalık kontrolün üzerinden geçen gün — hiç
 *                      yapılmadıysa `null`.
 * @param teslimGun     Teslimin üzerinden geçen gün — teslim edilmediyse `null`.
 */
export function kontrolBilgisi(sonKontrolGun, teslimGun) {
    const gecenGun = sonKontrolGun ?? teslimGun;
    return {
        hicYapilmadi: sonKontrolGun == null,
        gecenGun,
        kalanGun: gecenGun == null ? null : KONTROL_PERIYOT_GUN - gecenGun,
        durum: kontrolDurumu(gecenGun),
    };
}
//# sourceMappingURL=kontrol.js.map